<style>
.comment-modal-wide {
  max-width: 80vw !important;
}
.table .comment-origin-row {
  background-color: #eaf1fb !important;
}
.email-cell {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style scoped>
.nameFields {
  font-weight: bold;
  text-align: right;
}

.feedData {
  text-align: left;
}
</style>

<template>
  <div id="app">
    <NavComponent />
    <b-col cols="4">

      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 10px 0 10px 12px;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">숨김</small>
          <b-dropdown
            id="dropdown-1"
            :text="dropdownHideFilterType"
            :variant="dropdownHideFilterType !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('none')">none</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('전체숨김')">전체숨김</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('신고누적숨김')">신고누적숨김</b-dropdown-item>
            <b-dropdown-item @click="changeHideCategoryFilterDropbox('작외숨')">작외숨</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">삭제</small>
          <b-dropdown
            id="dropdown-is-delete"
            :text="dropdownIsDeleteFilter"
            :variant="dropdownIsDeleteFilter !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeIsDeleteFilter('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeIsDeleteFilter('삭제됨')">삭제됨</b-dropdown-item>
            <b-dropdown-item @click="changeIsDeleteFilter('삭제안됨')">삭제안됨</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">삭제 유형</small>
          <b-dropdown
            id="dropdown-deleted-by"
            :text="deletedByFilterLabel"
            :variant="selectedDeletedByFilters.length > 0 ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-form>
              <b-form-checkbox-group
                v-model="selectedDeletedByFilters"
                :options="deletedByOptions"
                stacked
                @change="onDeletedByFilterChange"
              ></b-form-checkbox-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">유형</small>
          <b-dropdown
            id="dropdown-content-type"
            :text="dropdownContentTypeFilter"
            :variant="dropdownContentTypeFilter !== 'all' ? 'info' : 'secondary'"
            size="sm"
          >
            <b-dropdown-item @click="changeContentTypeFilter('all')">all</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('일반')">일반</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('사진')">사진</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('영상')">영상</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('음성')">음성</b-dropdown-item>
            <b-dropdown-item @click="changeContentTypeFilter('GIF')">GIF</b-dropdown-item>
          </b-dropdown>
        </div>
        <span class="text-muted">|</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <small class="text-muted font-weight-bold">검색</small>
          <b-dropdown id="dropdown-search-type" :text="dropdownSearchType" size="sm">
            <b-dropdown-item @click="changeDropboxSearchType('email')">email</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxSearchType('callRoom')">callRoom</b-dropdown-item>
            <b-dropdown-item @click="changeDropboxSearchType('text')">text</b-dropdown-item>
          </b-dropdown>
          <b-input-group size="sm" style="width: 200px;">
            <b-form-input
              v-model="keyword"
              placeholder="검색어 입력"
              @keyup.enter="getFeedsByEmail"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info" :disabled="!keyword.trim()" @click="getFeedsByEmail">
                Search
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-button
          v-if="isFilterActive"
          variant="outline-danger"
          size="sm"
          class="ml-1"
          @click="getDefaultSearch()"
        >
          초기화
        </b-button>
      </div>
    </b-col>
    <div style="display: flex; justify-content: flex-start; margin-left: 10px">
      <b-p v-if="isSearch">
        {{ dropdownSearchType }}: "{{ searchedKeyword }}" 로 검색한
        결과입니다.</b-p
      >
    </div>
    <div style="display: flex; width: 100%; justify-content: flex-start; align-items: center; gap: 12px; padding: 10px 0 10px 12px;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <small class="text-muted font-weight-bold">숨김 처리</small>
        <b-dropdown id="dropdown-hide-action" :text="dropdownHideType" size="sm">
          <b-dropdown-item @click="changeHideDropboxHideType('none')">none</b-dropdown-item>
          <b-dropdown-item @click="changeHideDropboxHideType('전체숨김')">전체숨김</b-dropdown-item>
          <b-dropdown-item @click="changeHideDropboxHideType('신고누적숨김')">신고누적숨김</b-dropdown-item>
          <b-dropdown-item @click="changeHideDropboxHideType('작외숨')">작외숨</b-dropdown-item>
        </b-dropdown>
        <b-button variant="warning" size="sm" :disabled="Object.keys(selectedPosts).length === 0" @click="hideActionButton()">
          적용
        </b-button>
      </div>
      <span class="text-muted">|</span>
      <div style="display: flex; align-items: center; gap: 6px;">
        <small class="text-muted font-weight-bold">신고</small>
        <b-dropdown id="dropdown-report-action" :text="dropdownReportType" size="sm">
          <b-dropdown-item v-for="text in feedReasonList" :key="text" @click="changeDropboxReportType({ text })">{{text}}</b-dropdown-item>
        </b-dropdown>
        <b-button variant="danger" size="sm" :disabled="Object.keys(selectedPosts).length === 0" @click="createReportButton()">
          신고
        </b-button>
      </div>
    </div>

    <b-table hover :items="feedList" :fields="feedTableFields" small :tbody-tr-class="feedRowClass" style="cursor: pointer;" @row-clicked="(item) => checkboxChange(item.feedpost.feedpost_id, item.user.uuid)">
      <template #head(user.uuid)>
        <b-form-checkbox
          :checked="isAllPostsSelected"
          @change="toggleSelectWholePosts()"
        />
      </template>
      <template #cell(user.uuid)="row">
        <b-form-checkbox
          :checked="!!selectedPosts[row.item.feedpost.feedpost_id]"
          name="checkbox-feedpost"
          @change="checkboxChange(row.item.feedpost.feedpost_id, row.item.user.uuid)"
        >
        </b-form-checkbox>
      </template>

      <template #cell(feedpost.total_count_comments)="row">
        <b-button
          class="mr-2"
          size="sm"
          :disabled="!row.item.feedpost.total_count_comments"
          @click="
            getComments(row.item.feedpost.feedpost_id);
            $bvModal.show('commentModal');
          "
        >
          {{ row.item.feedpost.total_count_comments }}
        </b-button>
      </template>
      <template #cell(user.email)="row">
        <b-button
          class="mr-2"
          size="sm"
          style="max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;"
          :title="row.item.user.email"
          @click="openAdminUserPage(row.item.user.email)"
        >
          {{ row.item.user.email }}
        </b-button>
      </template>
      <template #cell(feedpost.feedpost_id)="row">
        <b-button
          size="sm"
          class="mr-2"
          @click="openFeedContent(row.item.feedpost.feedpost_id, row.item)"
        >
          VIEW
        </b-button>
      </template>
      <template #cell(feedpost.content.text)="row">
        <div style="word-break: break-all">
          <template v-if="row.item.feedpost.content.text && row.item.feedpost.content.text.length > 70">
            {{ row.item._textExpanded
              ? row.item.feedpost.content.text
              : row.item.feedpost.content.text.substring(0, 70) + '...' }}
            <b-link @click.stop="$set(row.item, '_textExpanded', !row.item._textExpanded)">
              {{ row.item._textExpanded ? '접기' : '더보기' }}
            </b-link>
          </template>
          <template v-else>
            {{ row.item.feedpost.content.text }}
          </template>
        </div>
      </template>
      <template #cell(feedpost.created_at)="row">
        {{ getTimeStamp(row.item.feedpost.created_at) }}
      </template>
      <template #cell(feedpost.deleted_at)="row">
        {{ row.item.feedpost.deleted_at ? getTimeStamp(row.item.feedpost.deleted_at) : '-' }}
      </template>

      <template #cell(preview)="row">
        <div
          v-if="row.item.feedpost.content._originalType === 'IMAGE' && row.item.feedpost.content.url && row.item.feedpost.content.url.length > 0"
          style="display: flex; overflow-x: auto; gap: 4px; max-width: 200px; cursor: pointer;"
          @click.stop="openPreviewModal(row.item.feedpost.content.url)"
        >
          <b-img
            v-for="(img, idx) in row.item.feedpost.content.url"
            :key="idx"
            :src="img.url"
            :alt="row.item.feedpost.content.text || '피드 이미지 미리보기'"
            style="height: 80px; width: auto; flex-shrink: 0;"
          />
        </div>
        <audio
          v-else-if="row.item.feedpost.content._originalType === 'AUDIO' && row.item.feedpost.content.url && row.item.feedpost.content.url.length > 0"
          controls
          preload="none"
          :src="row.item.feedpost.content.url[0].url"
          :aria-label="row.item.feedpost.content.text || '피드 음성 미리보기'"
          style="max-width: 200px"
        ></audio>
      </template>
      <template #cell(feedpost.is_delete)="row">
        <b-icon :icon="row.item.feedpost.is_delete ? 'check-circle' : 'x-circle'" :variant="row.item.feedpost.is_delete ? 'success' : 'danger'"></b-icon>
      </template>
      <template #cell(feedpost.deleted_by)="row">
        <b-badge v-if="row.item.feedpost.deleted_by === 'USER'" variant="secondary">본인</b-badge>
        <b-badge v-else-if="row.item.feedpost.deleted_by === 'ADMIN'" variant="danger">관리자</b-badge>
        <b-badge v-else-if="row.item.feedpost.deleted_by === 'SYSTEM_WITHDRAWAL'" variant="dark">회원탈퇴</b-badge>
        <span v-else>-</span>
      </template>

      <template #cell(feedpost.is_profile_exchange)="row">
        <b-form-checkbox
          v-model="isProfileExchange"
          name="checkbox-2"
          :value="row.item.feedpost.is_profile_exchange"
          disabled="true"
        >
        </b-form-checkbox>
      </template>
    </b-table>

    <b-modal id="commentModal" hide-footer size="xl" dialog-class="comment-modal-wide">
      <template #modal-title>
        {{ feedOriginId.substring(0, 8) }}...
        <div style="font-size: small;">
          <b-span>선택된 댓글  {{ Object.keys(selectedComments).filter(
              (key) => selectedComments[key] === "accepted"
            ).length }}개</b-span>
            
          <b-dropdown
            id="dropdown-hide-comment"
            :text="commentDropdownHideType"
            class="m-md-2"
          >
            <b-dropdown-item @click="changecommentDropdownHideType('none')">none</b-dropdown-item>
            <b-dropdown-item @click="changecommentDropdownHideType('전체숨김')">전체숨김</b-dropdown-item>
            <b-dropdown-item @click="changecommentDropdownHideType('신고누적숨김')">신고누적숨김</b-dropdown-item>
            <b-dropdown-item @click="changecommentDropdownHideType('작외숨')">작외숨</b-dropdown-item>
          </b-dropdown>
          <b-button class="mr-2" size="sm" :disabled="Object.keys(selectedComments).filter(k => selectedComments[k] === 'accepted').length === 0" @click="hideCommentActionButton()">
            액션
          </b-button>
        </div>
        
      </template>
      <b-table
        hover
        :items="comments"
        small
        :fields="commentTableFields"
        fixed
        style="word-break: break-all; cursor: pointer;"
        :tbody-tr-class="commentModalRowClass"
        @row-clicked="(item) => commentCheckboxChange(item.id)"
      >
      <template #head(selected)>
        <b-form-checkbox
          :checked="comments.length > 0 && Object.keys(selectedComments).filter(k => selectedComments[k] === 'accepted').length === comments.length"
          @change="toggleSelectWholeComments()"
        />
      </template>
      <template #cell(selected)="row">
        <b-form-checkbox
            :checked="selectedComments[row.item.id] === 'accepted'"
            @change="commentCheckboxChange(row.item.id)"
        ></b-form-checkbox>
        </template>
        <template #cell(id)="row">
          <b-button
            size="sm"
            class="mr-2"
            @click="openFeedComment(row.item.uuid, row.item.id)"
          >
            {{ row.item.id.substring(0, 8) }}...
          </b-button>
        </template>
        <template #cell(email)="row">
          <b-button
            size="sm"
            class="mr-2"
            @click="openAdminUserPage(row.item.email)"
          >
            {{ row.item.email.split("@")[0] }}
          </b-button>
        </template>
        <template #cell(content)="row">
          <div style="word-break: break-all">
            <template v-if="row.item.content && row.item.content.length > 30">
              {{ row.item._textExpanded
                ? row.item.content
                : row.item.content.substring(0, 30) + '...' }}
              <b-link @click.stop="$set(row.item, '_textExpanded', !row.item._textExpanded)">
                {{ row.item._textExpanded ? '접기' : '더보기' }}
              </b-link>
            </template>
            <template v-else>
              {{ row.item.content }}
            </template>
          </div>
        </template>
        <template #cell(contentPreview)="row">
          <audio
            v-if="row.item.content_type === 'AUDIO' && row.item.contentUrl && row.item.contentUrl.length > 0"
            controls
            preload="none"
            :src="row.item.contentUrl[0].url"
            style="max-width: 200px"
          ></audio>
          <div
            v-else-if="row.item.content_type === 'IMAGE' && row.item.contentUrl && row.item.contentUrl.length > 0"
            style="display: flex; overflow-x: auto; gap: 4px; max-width: 200px; cursor: pointer;"
            @click.stop="openPreviewModal(row.item.contentUrl)"
          >
            <b-img
              v-for="(img, idx) in row.item.contentUrl"
              :key="idx"
              :src="img.url"
              alt="댓글 이미지 미리보기"
              style="height: 60px; width: auto; flex-shrink: 0;"
            />
          </div>
          <span v-else>-</span>
        </template>
        <template #cell(is_delete)="row">
          <b-icon :icon="row.item.is_delete ? 'check-circle' : 'x-circle'" :variant="row.item.is_delete ? 'success' : 'danger'"></b-icon>
        </template>
        <template #cell(mentionedUser)="row">
          <b-button
          v-if = "row.item.mentioned_user"
            size="sm"
            class="mr-2"
            @click="openAdminUserPage(row.item.mentioned_user.email)">
            {{ row.item.mentioned_user.email.split("@")[0] }}
          </b-button>
          
        </template>
      </b-table>
      <b-button class="mt-3" block @click="$bvModal.hide('commentModal')"
        >닫기</b-button
      >
    </b-modal>

    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li
          class="page-item"
          v-for="item in createPageArray()"
          v-bind:key="item"
        >
          <a
            :style="[
              isPageButtonActive(item) ? { 'background-color': '#EC9E8E' } : {},
            ]"
            class="page-link"
            href="#"
            v-on:click="getFeeds(item)"
            >{{ item }}</a
          >
        </li>
        <!-- <li v-on:click="test()" class="page-item"><a class="page-link" href="#">Previous</a></li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item"><a class="page-link" href="#">Next</a></li> -->
      </ul>
    </nav>
    <ImagePreviewModal modalId="feedPreviewModal" :images="previewImages" />
  </div>
</template>

<script>
import NavComponent from "./NavComponent.vue";
import ImagePreviewModal from "./ImagePreviewModal.vue";

export default {
  name: "FeedContent",
  components: {
    NavComponent,
    ImagePreviewModal,
  },
  data() {
    return {
      previewImages: [],
      feedTableFields: [
        { key: "user.uuid", label: "" },
        { key: "feedpost.feedpost_id", label: "feedpost_id" },
        { key: "user.email", label: "email", thStyle: { width: "180px" }, tdClass: "email-cell" },
        { key: "feedpost.content.type", label: "content type" },
        { key: "feedpost.content.text", label: "text", thStyle: { width: "400px" } },
        { key: "preview", label: "미리보기", thStyle: { width: "130px" } },
        { key: "feedpost.total_count_comments", label: "댓글" },
        { key: "feedpost.total_count_likes", label: "좋아요" },
        { key: "feedpost.total_count_reports", label: "신고" },
        { key: "feedpost.hide", label: "숨김" },
        { key: "feedpost.is_delete", label: "삭제" },
        { key: "feedpost.deleted_by", label: "삭제 유형" },
        { key: "feedpost.deleted_at", label: "deleted_at" },
        { key: "feedpost.created_at", label: "created_at" },
      ],
      feedList: [],
      feedReasonList: ["none"],
      commentTableFields: [
        {key:"selected", label:"", thStyle: { width: "40px" }},
        {key:"comment", label:"종류", thStyle: { width: "60px" }},
        {key:"id", label:"id", thStyle: { width: "90px" }},
        {key:"email", label:"작성자", thStyle: { width: "100px" }},
        {key:"mentionedUser", label:"멘션", thStyle: { width: "100px" }},
        {key:"content_type", label:"유형", thStyle: { width: "80px" }},
        {key:"content", label:"text"},
        {key:"contentPreview", label:"미리보기", thStyle: { width: "220px" }},
        {key:"likesCount", label:"좋아요", thStyle: { width: "55px" }},
        {key:"reportsCount", label:"신고", thStyle: { width: "55px" }},
        {key:"is_delete", label:"삭제", thStyle: { width: "50px" }},
        {key:"hide", label:"숨김", thStyle: { width: "100px" }},
        {key:"created_at", label:"작성일", thStyle: { width: "140px" }},

      ],
      comments: [],
      feedOriginId: "", // 모달에서 선택된 피드의 id
      feedPage: 1,
      keyword: "",
      searchUserUuid: "",
      page: 0,
      loginCountry: this.$session.get("country"),
      apiBaseUrl: "",
      isSearch: false,
      selectedPosts: {},
      selectedComments: {},
      dropdownHideType: "none",
      commentDropdownHideType: "none",
      dropdownHideFilterType: "all",
      dropdownIsDeleteFilter: 'all',
      dropdownContentTypeFilter: 'all',
      selectedDeletedByFilters: [],
      deletedByOptions: [
        { text: '본인', value: 'USER' },
        { text: '관리자', value: 'ADMIN' },
        { text: '회원탈퇴', value: 'SYSTEM_WITHDRAWAL' },
      ],
      dropdownReportType: "none",
      dropdownSearchType: "email",
      isProfileExchange: true,
      searchedKeyword: "",
      hideCategory: {
        "none": "NONE",
        "전체숨김": "CS",
        "신고누적숨김": "REPORT",
        "작외숨": "OWN"
      },
      reportType: {
        "none": "NONE",
      }
    };
  },
  beforeMount() {
    this.apiBaseUrl = process.env.VUE_APP_FEED_SERVICE_URL;
    this.getFeeds(this.page);
    this.getReasonKey();
  },

  computed: {
    isAllPostsSelected() {
      return this.feedList.length > 0 && Object.keys(this.selectedPosts).length === this.feedList.length;
    },
    deletedByFilterLabel() {
      if (this.selectedDeletedByFilters.length === 0) return 'all';
      const labelMap = { USER: '본인', ADMIN: '관리자', SYSTEM_WITHDRAWAL: '회원탈퇴' };
      return this.selectedDeletedByFilters.map(v => labelMap[v]).join(', ');
    },
    isFilterActive() {
      return this.dropdownHideFilterType !== 'all'
        || this.dropdownIsDeleteFilter !== 'all'
        || this.dropdownContentTypeFilter !== 'all'
        || this.selectedDeletedByFilters.length > 0
        || this.isSearch;
    },
  },
  methods: {
    openPreviewModal(images) {
      this.previewImages = images;
      this.$bvModal.show('feedPreviewModal');
    },
    feedRowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.feedpost.total_count_reports >= 1) return 'table-warning'
    },
    test() {
      alert("AA");
    },
    getHeader() {
      return {
              Authorization: this.$session.get("token"),
              uuid: this.$session.get("uuid"),
            }
    },
    isPageButtonActive(currentP) {
      return currentP == this.page ? true : false;
    },
    changeHideDropboxHideType(value) {
      this.dropdownHideType = value;
    },
    changecommentDropdownHideType(value) {
      this.commentDropdownHideType = value;
    },
    changeDropboxReportType(value) {
      this.dropdownReportType = value.text;
    },
    changeDropboxSearchType(value) {
      this.dropdownSearchType = value;

    },
    async changeHideCategoryFilterDropbox(value){
      this.dropdownHideFilterType = value
      await this.getFeeds(this.page)

    },
    changeIsDeleteFilter(value) {
      this.dropdownIsDeleteFilter = value
      this.getFeeds(0)
    },
    changeContentTypeFilter(value) {
      this.dropdownContentTypeFilter = value
      this.getFeeds(0)
    },
    onDeletedByFilterChange() {
      this.getFeeds(0)
    },
    async hideActionButton() {
      await this.$http
        .put(
          `${this.apiBaseUrl}/management/feedposts/batch`,
          {
            feedpostIds: Object.keys(this.selectedPosts),
            data: {
              hide: this.hideCategory[this.dropdownHideType],
            },
          },
          {
            headers:this.getHeader()
          }
        )
        .then(async (res) => {
          if (res.status === 200) {
            alert("success");
            this.selectedPosts = {};
            await this.getFeeds(this.page);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    async createReportButton() {
      console.log(this.dropdownReportType, this.reportType[this.dropdownReportType], this.selectedPosts)
      if(this.reportType[this.dropdownReportType] == "NONE"){
        alert("신고 사유를 선택해주세요");
      } else if(Object.keys(this.selectedPosts).length>1) {
        alert("한개의 피드만 선택해주세요");
      } else{
        await this.$http
        .post(`${process.env.VUE_APP_API}/report/v4/report`, {
          "reason_key": this.reportType[this.dropdownReportType],
          "report_content": "관리자 신고",
          "domain": "FEED",
          "obj_id": Object.keys(this.selectedPosts)[0]
        }, {
          headers: {
            'Authorization': this.$session.get('token'),
            'Remote-user': Object.values(this.selectedPosts)[0]
          }
        }).then(async (res) => {
          if(res.status === 201) {
            alert("success");
            this.selectedPosts = {};
            await this.getFeeds(this.page);
          }else if(res.status === 200) {
            alert("이미 관리자 신고처리 된 데이터입니다");
          }
        }).catch((err) => {
          alert(err);
        })
      }
    },
    checkboxChange(post_id, uuid) {
      const exists = post_id in this.selectedPosts;
      if (exists) {
        this.$delete(this.selectedPosts, post_id);
      } else {
        this.$set(this.selectedPosts, post_id, uuid);
      }
    },
    toggleSelectWholePosts() {
      if (Object.keys(this.selectedPosts).length === this.feedList.length) {
        this.selectedPosts = {};
      } else {
        this.feedList.forEach((item) => {
          this.$set(this.selectedPosts, item.feedpost.feedpost_id, item.user.uuid);
        });
      }
    },
    commentCheckboxChange(comment_id){
      if (this.selectedComments[comment_id] === 'accepted') {
        this.$delete(this.selectedComments, comment_id)
      } else {
        this.$set(this.selectedComments, comment_id, 'accepted')
      }
    },
    createPageArray() {
      let list = [];

      let b = parseInt(this.page / 10);
      let f = false;
      for (var i = 0; i < 12; i++) {
        if (b >= 1 && !f) {
          f = true;
          list.push(b * 10 + i - 1);
        }
        list.push(b * 10 + i);
      }

      return list;
    },
    getTimeStamp(created_at) {
      return this.$moment(created_at).format("YY/MM/DD HH:mm");
    },
    openAdminUserPage(email) {
      window.open(
        `${process.env.VUE_APP_DJANGO_URL}/ko/yp/manage/service/admin/account/user/by-email/?email=${email}`
      );
    },
    getComments(activityId) {
      this.$http
        .get(`${this.apiBaseUrl}/management/feedposts/${activityId}/comments/`,
          {
            headers:this.getHeader()
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.feedOriginId = activityId;
            this.filterComments(res.data.data.comments);
            
          }
        })
        .catch((err) => {
          alert(err);
        }).finally(() =>{
          this.selectedComments = {};
        })
    },
    filterComments(commentData) {
      
      let comments = []

      commentData.forEach((comment) => {
        let bigCommentList = [];
        if (comment.children.length > 0) {
          comment.children.forEach((bigComment) => {
            bigCommentList = [
              {
                uuid: bigComment.user.uuid,
                comment: "┗",
                parent_id: comment.comment.comment_id,
                id: bigComment.comment.comment_id,
                content_type: bigComment.comment.content.type,
                content: bigComment.comment.content.text,
                contentUrl: bigComment.comment.content.url,
                contentDuration: bigComment.comment.content.duration,
                likesCount: bigComment.comment.total_count_likes,
                reportsCount: bigComment.comment.total_count_reports,
                is_delete: bigComment.comment.is_delete,
                hide: bigComment.comment.hide,
                email: bigComment.user.email,
                created_at: this.$moment(bigComment.comment.created_at).format(
                  "YY/MM/DD_HH:mm"
                ),
                mentioned_user: bigComment.comment.mentioned_user,
              },
              ...bigCommentList,
            ];
          });
        }
        comments = [
          {
            comment: "origin",
            uuid: comment.user.uuid,
            id: comment.comment.comment_id,
            content_type: comment.comment.content.type,
            content: comment.comment.content.text,
            contentUrl: comment.comment.content.url,
            contentDuration: comment.comment.content.duration,
            likesCount: comment.comment.total_count_likes,
            reportsCount: comment.comment.total_count_reports,
            is_delete: comment.comment.is_delete,
            hide: comment.comment.hide,
            email: comment.user.email,
            created_at: this.$moment(comment.comment.created_at).format(
              "YY/MM/DD_HH:mm"
            ),
          },
          ...bigCommentList,
          ...comments,
        ];
      });
      this.comments = [];
      
      this.$set(this, 'comments', comments) 
      console.log("comments",this.comments)
    },
    createUrl(page) {
      let apiURL = "";
      const baseUrl = `${this.apiBaseUrl}/management/feeds/search`
      const queryParams = new URLSearchParams();
      if (page) {
          queryParams.append('page', page)
      } else {
        queryParams.append('page', 0)
      }

      if (this.dropdownHideFilterType != 'all') {
        queryParams.append('hide[0]', this.hideCategory[this.dropdownHideFilterType])
      }

      // isDelete 필터
      if (this.dropdownIsDeleteFilter !== 'all') {
        const isDeleteValue = this.dropdownIsDeleteFilter === '삭제됨' ? 'true' : 'false'
        queryParams.append('isDelete', isDeleteValue)
      }

      // contentType 필터
      const contentTypeMap = {
        '일반': 'NORMAL',
        '사진': 'IMAGE',
        '영상': 'VIDEO',
        '음성': 'AUDIO',
        'GIF': 'GIF',
      }
      if (this.dropdownContentTypeFilter !== 'all') {
        const mappedContentType = contentTypeMap[this.dropdownContentTypeFilter]
        if (mappedContentType) {
          queryParams.append('contentType[0]', mappedContentType)
        }
      }

      // deletedBy 필터
      this.selectedDeletedByFilters.forEach(value => {
        queryParams.append('deletedBy', value)
      })

      if (this.isSearch) {
        const keyword = this.keyword.trim();
        switch (this.dropdownSearchType) {
          case "email":
            queryParams.append('email', keyword);
            break;
          case "callRoom":
            queryParams.append('callRoomId', keyword);
            break;
          case "text":
            queryParams.append('text', keyword);
            break;
        }
        apiURL = `${baseUrl}?${queryParams.toString()}`
      } else {
        apiURL = `${this.apiBaseUrl}/management/feeds/by-country?${queryParams.toString()}`;
      }
      return apiURL
    },

    async getReasonKey() {
      this.$http
      .get(process.env.VUE_APP_API + "/management/report/control_reasons/", {
        params: { domain: "FEED" },
        headers: { Authorization: this.$session.get("token") },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log("reason:", res.data.data);
          // 서버가 위치별 활성 사유를 도메인맵 순서대로 내려주므로 그대로 쓴다
          res.data.data.forEach((reason) => {
            let translatedText = "";
            switch (this.loginCountry){
              case "EN":
                translatedText = reason.description_en;
                break;
              case "JP":
                translatedText = reason.description_ja;
                break;
              default:
                translatedText = reason.description_ko;
                break;
            }
            this.feedReasonList.push(translatedText);
            this.reportType[translatedText] = reason.key;
          });
          console.log(this.feedReasonList, this.reportType)
        }
      })
      .catch((err) => {
        alert("report reasons Error" + err);
      });
    },

    async getFeeds(page) {

      const url = this.createUrl(page)
      await this.$http
        .get(url, { headers:this.getHeader()})
        .then((res) => {
          this.page = page;

          let items = [];
          if (Object.keys(res.data.data).length === 0) {
            res;
          }
          for (let it of res.data.data.feed_list) {
            if (it != null) {
              if (it.feedpost.access === "PUBLIC") {
                it.feedpost.access = "전체";
              } else if (it.feedpost.access === "PRIVATE") {
                it.feedpost.access = "팔로우";
              }

              it.feedpost.content._originalType = it.feedpost.content.type;

              if (it.feedpost.content.type === "IMAGE") {
                it.feedpost.content.type = "사진";
              } else if (it.feedpost.content.type === "AUDIO") {
                it.feedpost.content.type = "음성";
              } else if (it.feedpost.content.type === "CALL_ROOM") {
                it.feedpost.content.type = "룸공유";
              } else if (it.feedpost.content.type === "NORMAL") {
                it.feedpost.content.type = "일반";
              }

              if (it.feedpost.hide == "CS") {
                it.feedpost.hide = "전체숨김";
              } else if (it.feedpost.hide == "REPORT") {
                it.feedpost.hide = "신고누적숨김";
              } else if (it.feedpost.hide == "OWN") {
                it.feedpost.hide = "작외숨";
              } else if (it.feedpost.hide == "NONE") {
                it.feedpost.hide = "none";
              }


              items.push(it);
            }
          }

          this.feedList = items;
          this.selectedPosts = {};
          console.log(
            "🚀 ~ file: FeedContentSearch.vue ~ line 432 ~ getFeeds ~ items",
            items
          );
        })
        .catch((err) => {
          alert(err);
        });
    },
    toggleSelectWholeComments() {
      if (Object.keys(this.selectedComments).length === this.comments.length) {
        this.selectedComments = {};
      } else {
        this.comments.forEach((comment) => {
          this.$set(this.selectedComments, comment.id, "accepted");
        })
      }
    
  
    },
    async getFeedsByEmail() {
      if (this.keyword === "") {
        return
      }

      if (!this.isSearch) {
        this.page = 0;
        this.isSearch = true;
      }
      this.getFeeds(this.page);
      this.searchedKeyword = this.keyword;
    },

    async getDefaultSearch() {
      this.dropdownSearchType = "email";
      this.dropdownHideFilterType = "all";
      this.dropdownIsDeleteFilter = "all";
      this.dropdownContentTypeFilter = "all";
      this.selectedDeletedByFilters = [];
      this.searchedKeyword = "";
      this.keyword = "";
      this.isSearch = false;
      this.page = 0;
      this.getFeeds(this.page);
    },
    openFeedContent(id, feed) {
      const routeData = this.$router.resolve({
        name: "feedContent",
        params: { id: id, feed: feed },
      });
      window.open(routeData.href, "_blank");
    },
    openFeedComment(userId, commentId) {
      console.log("F", userId, commentId);
      const routeData = this.$router.resolve({
        name: "feedComment",
        params: { user_id: userId, comment_id: commentId },
      });
      console.log("FFFF", routeData);
      window.open(routeData.href, "_blank");
    }, 
    commentModalRowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.reportsCount >= 1) return 'table-warning'
      if (item.comment === 'origin') return 'comment-origin-row'
    },
    async hideCommentActionButton() {
      const commentIds = Object.keys(this.selectedComments).filter(
        (key) => this.selectedComments[key] === "accepted"
      );
      await this.$http
        .put(
          `${this.apiBaseUrl}/management/comments/batch`,
          {
            commentIds,
            data: {
              hide: this.hideCategory[this.commentDropdownHideType],
            },
          },
          {
            headers:this.getHeader()
          }
        )
        .then((res) => {
          if (res.status === 200) {
            alert("success");
            this.selectedComments = {};
            this.getComments(this.feedOriginId)
          }
        })
        .catch((err) => {
          alert(err);
        });
      
    },
  },
};
</script>

<style scoped>
.nameFields {
  font-weight: bold;
  text-align: right;
}

.feedData {
  text-align: left;
}
</style>
